<template>
  <Layout is-demo>
    <h1 class="text-h4 ms-0 mb-1">Dashboard</h1>
    <v-row>
      <v-col cols="12" md="3" sm="6">
        <v-alert
          border="left"
          color="green lighten-1"
          dense
          text
          prominent
          icon="mdi-file-certificate"
        >
          <div class="text-caption green--text text--lighten-1">
            Sales Permit-New
          </div>
          <div class="green--text text--darken-2 text-h4 font-weight-light">
            {{ dashboardData.permit_new }}
          </div>
        </v-alert>
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <v-alert
          border="left"
          color="green lighten-1"
          dense
          text
          prominent
          icon="mdi-file-certificate-outline"
        >
          <div class="text-caption green--text text--lighten-1">
            Sales Permit-Renewal
          </div>
          <div class="green--text text--darken-2 text-h4 font-weight-light">
            {{ dashboardData.permit_renewal }}
          </div>
        </v-alert>
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <v-alert
          border="left"
          color="green lighten-1"
          dense
          text
          prominent
          icon="mdi-certificate"
        >
          <div class="text-caption green--text text--lighten-1">
            Certificate-New
          </div>
          <div class="green--text text--darken-2 text-h4 font-weight-light">
            {{ dashboardData.certificate_new }}
          </div>
        </v-alert>
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <v-alert
          border="left"
          color="green lighten-1"
          dense
          text
          prominent
          icon="mdi-certificate-outline"
        >
          <div class="text-caption green--text text--lighten-1">
            Certificate- Renewal
          </div>
          <div class="green--text text--darken-2 text-h4 font-weight-light">
            {{ dashboardData.permit_renewal }}
          </div>
        </v-alert>
      </v-col>
    </v-row>
  </Layout>
</template>

<script>
import Layout from '@/nfmp_components/layouts/MainPortalLayout'
import httpServ from '../services/HTTPService'
//import { Plotly } from 'vue-plotly'

export default {
  components: {
    Layout
  },
  data() {
    return {
      alterLOBFlag: false,
      someDate: '2023-05-03 00:00:00',
      userData: {},
      dashboardData: {
        certificate_new:0,
        certificate_renewal:0,
        permit_new:0,
        permit_renewal:0
      },
      tableIsLoaded: false,
      prePostData: {},
      currentLOBDetails: {},
      showAlert: true,
      fees: [],
      currentLOBname: ''
    }
  },
  created() {
    this.userData = httpServ.getSessionJson('userData')
    this.getSummaryData()
  },
  mounted() {
    this.$root.$on('get-dashbardTable-data', () => {
      //this.getTableData()
    })
  },
  methods: {
    getSummaryData: function () {
      const url = httpServ.getCertificateUrl('/admin/getDashboardSummary')
      const resp = httpServ.postFetchWithToken(
        url,
        this.prePostData,
        httpServ.getPaymentApiToken()
      )

      resp.then((result) => {
        if (result.status === 200) {
          this.summary = result.data
          this.summary.forEach((item) => {
            if (item.ranking === 'New') {
              if (item.lOB === 'Distributor') {
                ++this.dashboardData.permit_new
              } else {
                ++this.dashboardData.permit_renewal
              }
            } else {
              if (item.lOB === 'Distributor') {
                ++this.dashboardData.cetificate_new
              } else {
                ++this.dashboardData.certificate_renewal
              }
            }
          })
        }  else {
          //this.tableData = []
        }
      })
    }
  }
}
</script>

<style scoped>
.v-alert--prominent .v-alert__icon.v-icon {
  font-size: 32px;
  color: green;
}
.v-alert {
  color: green !important;
}
.card-header-text {
  font-weight: 400 !important;
  color: rgba(0, 0, 0, 0.87);
  padding-bottom: 20px;
}
.d-card-height {
  min-height: 500px !important;
}

::v-deep .v-data-table td {
  height: 20px !important;
  font-size: 14px !important;
}

::v-deep .v-data-table th {
  font-size: 12px !important;
}

.reg-guide-text {
  font-size: 13px !important;
}
</style>
